export default {
  summary: {
    delivery: 'Livraison : carte cadeau en PDF par e-mail',
  },
};
